// Chrome's bundled ICU has no month names for Bosnian and prints "2026 M10 7",
// so Bosnian dates are composed here. Other locales use Intl as before.
const BS_MONTHS_LONG = [
  'januara', 'februara', 'marta', 'aprila', 'maja', 'juna',
  'jula', 'augusta', 'septembra', 'oktobra', 'novembra', 'decembra',
]
const BS_MONTHS_SHORT = [
  'jan', 'feb', 'mar', 'apr', 'maj', 'jun',
  'jul', 'aug', 'sep', 'okt', 'nov', 'dec',
]

function parseDate(date: string): Date {
  return new Date(date.includes('T') ? date : `${date}T00:00:00Z`)
}

/** Formats a publish date in UTC so it does not shift with the reader's time zone. */
export function formatPostDate(
  date: string,
  locale: string,
  style: 'long' | 'short' = 'long',
): string {
  const d = parseDate(date)
  if (Number.isNaN(d.getTime())) return ''
  if (locale === 'bs' || locale.startsWith('bs-')) {
    const months = style === 'long' ? BS_MONTHS_LONG : BS_MONTHS_SHORT
    return `${d.getUTCDate()}. ${months[d.getUTCMonth()]} ${d.getUTCFullYear()}.`
  }
  return d.toLocaleDateString(locale, {
    month: style === 'long' ? 'long' : 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  })
}
